export interface ContactAddress {
  id: string;
  contactId: number;
  type: AddressType;
  addressLine1: string;
  addressLine2?: string;
  zipCode: string;
  city: string;
  state: string;
  country: string;
  createdAt?: string;
  updatedAt?: string;
}

export enum AddressType {
  PHYSICAL = 'PHYSICAL',
  POSTAL = 'POSTAL',
}

export interface CreateContactAddressDto {
  contactId: number;
  type: AddressType;
  addressLine1: string;
  addressLine2?: string;
  zipCode: string;
  city: string;
  state: string;
  country: string;
}

export interface UpdateContactAddressDto {
  type?: AddressType;
  addressLine1?: string;
  addressLine2?: string;
  zipCode?: string;
  city?: string;
  state?: string;
  country?: string;
}

export interface ContactAddressFilter {
  contactId?: number;
  page?: number;
  limit?: number;
}
